import sha256 from 'hash.js/lib/hash/sha/256';

export default function getVehicle(vehicle) {
    let car = {};

    if (vehicle?.licensePlate) {
        car['car_vrn_sha'] = sha256().update(vehicle.licensePlate.replaceAll('-', '').toUpperCase()).digest('hex');
    }
    if (vehicle?.brand) {
        car['car_brand'] = vehicle.brand.toLowerCase();
    }
    if (vehicle?.model) {
        car['car_type'] = vehicle.model.toLowerCase();
    }
    if (vehicle?.brand && vehicle?.model) {
        car['car_brand_type'] = `${vehicle.brand.toLowerCase()} ${vehicle.model.toLowerCase()}`;
    }
    if (vehicle?.leaseType) {
        car['car_lease_status'] = vehicle.leaseType;
    }
    if (vehicle?.mileage) {
        car['car_mileage'] = vehicle.mileage;
    }
    if (vehicle?.fuelType) {
        car['car_fuel'] = vehicle.fuelType.toLowerCase();
    }

    return Object.keys(car).length > 0 ? { car: car } : {};
}
